import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductService } from '../../services/productservice';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss'],
})
export class BlogComponent implements OnInit {
  public highlightData: any = null;
  public language: string = 'en';

  constructor(public routes: ActivatedRoute, public router: Router, private productService: ProductService) {}

  ngOnInit() {
    this.language = localStorage.getItem('language') || 'en';
    this.fetchData(0, this.language);
  }

  // async fetchData(pageNo: number, language: string): Promise<void> {
  //   try {
  //     const data = await this.productService.getHighlightSmallPagingDescOrder(pageNo, language);

  //     this.highlightData = {
  //       ...data,
  //       results: data?.results?.map((item: any) => ({
  //         ...item,
  //         title: this.decodeHtml(item.title),
  //         body: this.stripHtmlAndLimitChars(item.body),
  //       })),
  //     };
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // }

  async fetchData(pageNo: number, language: string): Promise<void> {
    try {
      const [highlightRes, featuredRes] = await Promise.all([
        this.productService.getHighlightSmallPagingDescOrder(pageNo, language),
        this.productService.getFeaturedBlogs(language),
      ]);

      let highlights = highlightRes?.results || [];
      let featured = featuredRes || [];

      // Normalize both
      highlights = highlights.map((item: any) => this.normalizeItem(item));
      featured = featured.map((item: any) => this.normalizeItem(item));

      let finalResults: any[] = [];

      if (featured.length > 0) {
        // Remove duplicates (same nid)
        const featuredIds = new Set(featured.map((f: any) => f.nid));
        const filteredHighlights = highlights.filter((h: any) => !featuredIds.has(h.nid));

        // 1 featured + next 3 highlights
        finalResults = [featured[0], ...filteredHighlights.slice(0, 3)];
      } else {
        // Default case (no featured)
        finalResults = highlights.slice(0, 4);
      }

      this.highlightData = {
        results: finalResults,
      };
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  normalizeItem(item: any): any {
    return {
      ...item,
      title: this.decodeHtml(item.title),
      body: this.stripHtmlAndLimitChars(item.body),
      uri: item.uri?.trim(),
    };
  }

  decodeHtml(input: string): string {
    if (!input) return '';
    const textarea = document.createElement('textarea');
    textarea.innerHTML = input;
    return textarea.value;
  }

  stripHtmlAndLimitChars(input: string, charLimit: number = 160): string {
    if (!input) return '';

    const textarea = document.createElement('textarea');
    textarea.innerHTML = input;
    let decoded = textarea.value;

    decoded = decoded.replace(/<[^>]*>/g, '');

    decoded = decoded
      .replace(/\u00A0|&nbsp;/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    return decoded.length <= charLimit ? decoded : decoded.slice(0, charLimit) + '...';
  }

  parseDate(dateStr: string): string {
    if (!dateStr) return '';
    const [datePart, timePart] = dateStr.split(' - ');
    if (!datePart || !timePart) return '';

    const parts = datePart.split('/').map((p) => p.trim());
    if (parts.length !== 3) return '';

    // Find the 4-digit year regardless of position (handles MM/DD/YYYY and YYYY/MM/DD)
    const yearIdx = parts.findIndex((p) => p.length === 4 && /^\d{4}$/.test(p));
    if (yearIdx === -1) return ''; // malformed / non-numeric (defensive guard)

    const year = parts[yearIdx];
    const rest = parts.filter((_, i) => i !== yearIdx);
    const [month, day] = rest;

    if (!/^\d+$/.test(month) || !/^\d+$/.test(day)) return '';

    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${timePart}`;
  }

  itemClick(item: any): void {
    const queryParams = this.productService.getBlogViewNode(item);
    const url = '/blog-details/' + item.nid + '/' + queryParams;
    window.open(url, '_blank');
  }
}
